<script>
  import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}
  <main>
    <br />
    <div class="gua-xu-song center show-book">
      <h4>【卦序歌】</h4>
      <p>
        乾坤屯蒙需訟師，比小畜兮履泰否，<br />
        同人大有謙豫隨，蠱臨觀兮噬嗑賁，<br />
        剝復無妄大畜頤，大過坎離三十備。
      </p>
      <hr />
      <p>
        咸恆遯兮及大壯，晉與明夷家人睽，<br />
        蹇解損益夬姤萃，升困井革鼎震繼，<br />
        艮漸歸妹豐旅巽，兌渙節兮中孚至，<br />
        小過既濟兼未濟，是為下經三十四。
      </p>
      <br />
    </div>
  </main>
{:else}
  <main>
    <br />
    <div class="gua-xu-song center show-book">
      <h4>【卦序歌】</h4>
      <p>
        乾坤屯蒙需讼师，比小畜兮履泰否，<br />
        同人大有谦豫随，蛊临观兮噬嗑贲，<br />
        剥复无妄大畜颐，大过坎离三十备。
      </p>
      <hr />
      <p>
        咸恒遯兮及大壮，晋与明夷家人睽，<br />
        蹇解损益夬姤萃，升困井革鼎震继，<br />
        艮渐归妹丰旅巽，兑涣节兮中孚至，<br />
        小过既济兼未济，是为下经三十四。
      </p>
      <br />
    </div>
  </main>
{/if}

<style>
  .show-book {
    /* height: 400px; */
    font-size: 20px;
    font-weight: 300;
    padding-left: 20px;
    padding-right: 20px;
    margin-right: 10px;
    /* background-color: #eeeeff; */
    overflow-y: auto;
  }
  /* .gua-xu-song {
    padding-left: 10px;
  } */
</style>
